import {EvaluationSection} from "../javascript.lib.mojo-base/model/module/EvaluationSection";
import {IAnswer} from "../javascript.lib.mojo-base/model/Answer";
import {AspectAnswers} from "../javascript.lib.mojo-base/model/AspectAnswers";
import {
  getStorage,
  ref,
  getDownloadURL
} from "firebase/storage";

import {IFirebaseAnswersListener} from "../browser.lib.evaluation-tool/firebase/realtime-database/answers-x/FirebaseAnswers";
import {StorageReference} from "@firebase/storage";
import {LoggerFactory} from "../javascript.lib.mojo-base/log/LoggerFactory";
import {IFirebaseError} from "../javascript.lib.mojo-base/firebase/FirebaseAuthError";
import {FirebaseErrorCodes} from "../javascript.lib.mojo-base/firebase/FirebaseErrorCodes";


export class FirebaseAnswersListener implements IFirebaseAnswersListener {


  private _log = LoggerFactory.build( 'FirebaseAnswersListener' );


  private _allAnswers: { [questionKey: string]: IAnswer } = {};
  private _storageRoot: StorageReference;

  _questionKeyToPhotoUrlsMap: { [questionKey: string]: string[] } = {};
  _pathToPhotoUrlMap: { [path: string]: string } = {};
  private _photosNotFound: { [path: string]: boolean } = {};


  private async _updateAspectPhotos( propertyKey: string,
                                     aspectQuestions: EvaluationSection,
                                     answers: { [p: string]: IAnswer } | null ): Promise<boolean> {



    let aspectPhotosUpdated = false;

    for( const question of aspectQuestions.questions ) {

      if( !question.isPhoto ) {
        continue;
      }

      const answerValue = answers[question.value.key];

      if( !answerValue ) {
        continue;
      }

      if( !answerValue.value ) {
        continue;
      }

      const photoUrls: string[] = [];

      for( const photoTimestamp of answerValue.value ) {

        const path = `photos/${propertyKey}/${question.value.key}/${photoTimestamp}.popup.jpg`;

        const photoUrl = this._pathToPhotoUrlMap[path];
        if( photoUrl ) {

          photoUrls.push( photoUrl );
          continue;
        }

        if( !this._photosNotFound[photoUrl] ) {

          let imageRef = ref( this._storageRoot, path );
          try {

            const photoUrl = await getDownloadURL( imageRef );
            aspectPhotosUpdated = true;
            photoUrls.push( photoUrl );
            this._log.debug( 'photoUrl', photoUrl );

          } catch ( e ) {


            const firebaseError = e as IFirebaseError;

            if( FirebaseErrorCodes.storage.OBJECT_NOT_FOUND === firebaseError.code ) {
              this._photosNotFound[photoUrl] = true;
            }

            this._log.logError( 'exception caught', (event) => {
              event.value.context['code'] = firebaseError.code;
              event.value.context['message'] = firebaseError.message;
            } );
          }

        }

      }

      this._questionKeyToPhotoUrlsMap[question.value.key] = photoUrls;
    }

    return aspectPhotosUpdated;
  }

  private async _updatePhotoLinks(propertyKey: string, aspectQuestions: EvaluationSection, answers: { [p: string]: IAnswer } | null ) {


    if( await this._updateAspectPhotos( propertyKey, aspectQuestions, answers ) ) {

      const storageKey = `${propertyKey}.photos`;
      window.localStorage.setItem( storageKey, JSON.stringify( this._questionKeyToPhotoUrlsMap )  );

    }
  }


  private _updateAllAnswers(propertyKey: string, answers: { [questionKey: string]: IAnswer } | null) {

    if( !answers ) {
      return;
    }

    for( const questionKey of Object.keys( answers )) {

      this._allAnswers[questionKey] = answers[questionKey];
    }

    const storageKey = `${propertyKey}.answers`;
    window.localStorage.setItem( storageKey, JSON.stringify( this._allAnswers )  );

  }


  onReadValueXByKey(propertyKey: string, aspectQuestions: EvaluationSection, answers: { [questionKey: string]: IAnswer } | null) {

    if( null == answers ) {

      return;
    }

    // const storageKey = `${propertyKey}.${aspectQuestions.value.firebaseAspectId}.answers`;
    // window.localStorage.setItem( storageKey, JSON.stringify( answers )  );
    this._updateAllAnswers( propertyKey, answers );
    this._updatePhotoLinks( propertyKey, aspectQuestions, answers );
  }

  onWriteValueXByKey(propertyKey: string, aspectAnswers: AspectAnswers) {


    // const storageKey = `${propertyKey}.${aspectAnswers.aspectQuestions.value.firebaseAspectId}.answers`;
    // window.localStorage.setItem( storageKey, JSON.stringify( aspectAnswers.value )  );
    this._updateAllAnswers( propertyKey, aspectAnswers.value );
    this._updatePhotoLinks( propertyKey, aspectAnswers.aspectQuestions, aspectAnswers.value );
  }


  constructor() {

    const storage = getStorage();
    this._storageRoot = ref( storage );

  }
}
